import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  Suspense,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import {
  getEmployeeAwards,
  deleteEmployeeAwards,
  EmployeeAwardsYears,
  EmployeeAwardsGet,
} from "./Services/awardService";
import { TostMsg } from "../../../App";
import { Dropdown } from "primereact/dropdown";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import InfiniteScroll from "react-infinite-scroll-component";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";
const defaultAwardImage = "/images/no-data-found/Award_dummy.svg";

function AwardList() {
  const [loader, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [masterYear, setMasterYear] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const toster = useContext(TostMsg);
  const [file, setFile] = useState(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [awardDeleteId, setAwardDeleteId] = useState(0);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [masterCategoryData, setMasterCategoryData] = useState("");
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "");
  const [awardList, setAwardList] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [noData, setNoData] = useState([]);
  const [showAwardDataNotFound, setShowAwardDataNotFound] = useState(false);
  const [previousParams, setPreviousParams] = useState({
    year: "",
    category: 0,
  });
  let history = useHistory();
  const observer = useRef();

  useEffect(() => {
    getAwardList(selectedYear, selectedCategory, page);
    GetCategoryEmployeeAwards();
    getAwardYearList();
    permissionAwardList();
    GetMasterSystemAlertList("award_header", 1);
    GetMasterSystemAlertList("No_Award", 2);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {}, [masterCategoryData, selectedYear, selectedCategory]);

  // useEffect(() => {
  //   if (page > 1) {
  //     getAwardList(selectedYear, selectedCategory, page, true);
  //   }
  // }, [page]);

  const AwardDetailId = (event) => {
    history.push(`/Award/Detail/${event?.AwardNumber}`);
  };

  async function getAwardList(selectedYear, selectedCategory, page) {
    setLoading(true);
    const yearAllList =
      selectedYear == "All Years" ? "" : selectedYear.toString();
    const showAllCategory =
      selectedCategory === "All Awards" ? 0 : Number(selectedCategory) || 0;
    const params = {
      OrgId: userDetails?.OrgId || "",
      LoggedInUserId: 0,
      year: yearAllList,
      AwardNumber: "",
      Awardid: showAllCategory,
      PageNumber: page,
      PageSize: 24,
    };
    // if (yearAllList == "" && showAllCategory == 0) {
    //   setHasMore(true);
    // }
    try {
      const response = await getEmployeeAwards(params);
      const awardListData = response.Data;
      setLoading(false);
      if (page === 1) {
        setAwardList(awardListData);
      } else {
        setAwardList((prevAwards) => [...prevAwards, ...awardListData]);
      }

      if (awardListData.length <24){
        setHasMore(false);
      } else {
        setHasMore(true);
      setPage(page+1);
      }

      setPreviousParams({ year: yearAllList, category: showAllCategory });
    } catch (error) {
      toster.current.error("Error fetching awards:", error);
    } finally {
      setLoading(false);
    }
  } 

  async function editawards(awardDetails) {
    history.push(`/Award/Edit/${awardDetails?.AwardNumber}`);
  }

  async function deleteAcademicDetails() {
    setLoading(true);
    if (awardDeleteId) {
      let body = {
        Id: awardDeleteId,
        ModifiedBy: userDetails?.EmpId,
      };
      setLoading(true);
      try {
        let awardDeleteList = await deleteEmployeeAwards(body);
        if (awardDeleteList) {
          GetMasterSystemAlertList("Award_Deleted", 0);
          setAwardDeleteId(0);
        
          setPage(1);
          getAwardList(selectedYear, selectedCategory, 1);
          setLoading(false);

          document.getElementById("delete-ed").click();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  async function GetCategoryEmployeeAwards() {
    let body = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let responce = await EmployeeAwardsGet(body);
      let categoryData = responce?.Data?.toSpliced(0, 0, {
        id: 0,
        AwardName: "All Awards",
      });
      setMasterCategoryData(categoryData);
      setSelectedCategory(categoryData[0]?.id);
    } catch (err) {
      toster.current.error(ERROR_LIST.AwardMasterData);
    } finally {
    }
  }

  async function getAwardYearList() {
    const params = { OrgId: userDetails?.OrgId };
    try {
      const response = await EmployeeAwardsYears(params);
      let MasterDetails = await response;
      let yearDetail = response?.Data?.reverse().toSpliced(0, 0, {
        Year: "All Years",
      });
      setMasterYear(yearDetail);
      setSelectedYear(yearDetail[0]?.Year);
    } catch (err) {
      toster.current.error(ERROR_LIST.AwardYear);
    } finally {
    }
  }

  const handleInputChangeYear = (e) => {
    setPage(1);
    // setHasMore(true);
    setSelectedYear(e.value);
    getAwardList(e.value, selectedCategory, 1);
  };

  const handleInputChangeCategory = (e) => {
    setPage(1);
    setHasMore(false);
    setSelectedCategory(e.value);
    getAwardList(selectedYear, e.value, 1);
  };

  const lastAwardElementRef = useCallback(
    (node) => {
      if (loader) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          // setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loader, hasMore]
  );

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  const permissionAwardList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Award.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Award.Update") {
        setUpdate(true);
      } else if (UserPermission.PermissionName == "Award.Delete") {
        setDeleted(true);
      }
    });
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleAwardImageError = useCallback((event) => {
    event.target.src = defaultAwardImage;
  }, []);

  const handleFileChange = useCallback(async (event) => {
    const selectedFile = await event.target.files[0];
    setFile(selectedFile);
  }, []);

  return (
    <div>
      <div>
        <div id="circular-menu" className="circular-menu">
          <a className="floating-btn">
            <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
            <i aria-hidden="true" className="fa fa-times"></i>
          </a>

          <div className="items-wrapper">
            <div className="menu-item is-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </div>
            <a
              className="menu-item is-flex right-panel-trigger"
              data-panel="languages-panel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </a>
            <Link to="" className="menu-item is-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </Link>
            <a
              className="menu-item is-flex right-panel-trigger"
              data-panel="activity-panel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-grid"
              >
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
            </a>
          </div>
        </div>
        <div className="container-fluid">


          <InfiniteScroll
            dataLength={awardList?.length}
            next={() =>
              setTimeout(
                () => getAwardList(selectedYear, selectedCategory, page),
                700
              )
            }
            hasMore={hasMore}
            scrollableTarget="scrollableDiv"
            style={{ overflow: "hidden" }}
          >
            <div className="row g-3">
              <div className="form-head d-flex flex-wrap align-items-center">
                <div className="me-auto">
                  <h2 className="font-w600 mb-0">{T("Awards")}</h2>
                  <p className="text-light">{masterSystemAlertData}</p>
                </div>
                <div className="rightside-tabs">
                  <div className="me-2">
                    <div className="org-cate">
                      <Dropdown
                        name="Year"
                        value={selectedYear}
                        onChange={(e) => {
                          setSelectedYear(e.value);
                          handleInputChangeYear(e);
                        }}
                        options={masterYear}
                        optionLabel="Year"
                        optionValue="Year"
                        placeholder="Select a Year"
                        checkmark={true}
                        highlightOnSelect={false}
                      />
                    </div>
                  </div>
                  <div className="me-2">
                    <div className="org-cate">
                      <Dropdown
                        name="Category"
                        value={selectedCategory}
                        onChange={(e) => {
                          setSelectedCategory(e.value);
                          handleInputChangeCategory(e);
                        }}
                        options={masterCategoryData}
                        optionLabel="AwardName"
                        optionValue="id"
                        placeholder="Select a Category"
                        checkmark={true}
                        highlightOnSelect={false}
                      />
                    </div>
                  </div>
                  <div className="">
                    {create && (
                      <Link to="/Award/Add" title="New Award">
                        <div className="org-add">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-plus"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                          </svg>
                        </div>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
              <div className="">
                <div className="row g-3 mb-4">
                  {awardList?.map((awards, index) => {
                    const isLastElement = index === awardList.length - 1;
                    return (


                      <div
                        key={index}
                        className="col-xl-4"
                        ref={isLastElement ? lastAwardElementRef : null}
                        
                      >
                        <div className="card award-card" >
                          <div className="card-body mb-0 awards-div-list">
                            <div className="row" >
                              <div className="award-celebration">
                                <div
                                  className="name"
                                  style={{ cursor: "pointer" }}
                                  
                                >
                                  <span className="card-title" onClick={() => AwardDetailId(awards)}>
                                    {awards?.AwardName}
                                  </span>
                                  {/* <strong>{T('Awards')}</strong> */}
                                  <Link to={`/Profile/${awards?.EmployeeGUID}`}>
                                  <h5 className="d-flex align-items-center mt-1 mb-2">
                                    {awards?.EmployeeProfileImage ? (
                                      <LazyImage
                                        src={
                                          awards?.EmployeeProfileImage ||
                                          defaultImage
                                        }
                                        onError={handleImageError}
                                        width="80"
                                        height="80"
                                        style={{ opacity: "1" }}
                                        className=""
                                      />
                                    ) : (
                                      <LazyImage
                                        src={awards?.EmployeeProfileImage}
                                        className="w-100"
                                      />
                                    )}{" "}
                                    {awards?.EmployeeName}
                                  </h5>
                                  </Link>
                                  <ul onClick={() => AwardDetailId(awards)}>
                                    <li >
                                      {awards?.Desc?.length >= 60
                                        ? `${awards.Desc.substring(0, 60)}...`
                                        : awards?.Desc}
                                    </li>
                                  </ul>
                                </div>
                                <div
                                  className="img"
                                  style={{ maxWidth: "56px" }}
                                  onClick={() => AwardDetailId(awards)}
                                >
                                  {awards?.awardImage ? (
                                    <img
                                      src={
                                        awards?.awardImage || defaultAwardImage
                                      }
                                      onError={handleAwardImageError}
                                    />
                                  ) : (
                                    <img src="images/org-img/awards/1.png" />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="card-footer awards-div-list2">
                            <Link to={`/Award/Detail/${awards?.AwardNumber}`}>
                            <strong className="announced-by">
                              <p>
                                <img src="/images/policy/date.svg" />
                                {moment(awards?.Date).format("MMM DD YYYY")}
                              </p>
                            </strong>
                            </Link>
                            <div className="action-btns">
                              {update && (
                                <span
                                  onClick={() => editawards(awards)}
                                  className="btn me-1 edit "
                                  data-toggle="tooltip"
                                  data-placement="top"
                                >
                                  <img
                                    src="/images/tickets/edit-ico.svg"
                                    className="editdivinfo"
                                  />
                                </span>
                              )}
                              {deleted && (
                                <span
                                  className="btn delete"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-bs-toggle="modal"
                                  data-bs-target="#delete-ed"
                                  title=""
                                  data-bs-original-title="delete"
                                  aria-label="delete"
                                  onClick={() => setAwardDeleteId(awards?.id)}
                                >
                                  <img
                                    src="/images/tickets/delete.svg"
                                    className="editdivinfo"
                                  />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>


                    );
                  })}{" "}
                  {showAwardDataNotFound === true &&
                    awardList?.length === 0 && (
                      <div className="notfound">
                        <img src="/images/org-img/awards/nodata-found.png" />
                        <p>{noData}</p>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </InfiniteScroll>

          
        </div>
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this award?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="savebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAcademicDetails()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {loader ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default AwardList;
